export default "__VITE_ASSET__CJ$237Ez__"